module.exports = __webpack_public_path__ + "static/media/smartdrive_logo_light.ba6b250d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smartdrive_logo_light.svg
// module id = 556
// module chunks = 0